/* eslint-disable react/prop-types */
import React from 'react';
import { ClipLoader } from 'react-spinners';
import { NORMAL_STATE } from "../../../style/colors";
import { _Loading } from "./styles";
var Loading = function Loading(_ref) {
  var spinnerColor = _ref.spinnerColor,
    _ref$dataTestId = _ref.dataTestId,
    dataTestId = _ref$dataTestId === void 0 ? null : _ref$dataTestId;
  return /*#__PURE__*/React.createElement(_Loading, {
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(ClipLoader, {
    color: spinnerColor || NORMAL_STATE,
    size: 30
  }));
};
export default Loading;